import { render, staticRenderFns } from "./VehicleSchedulePageV4.vue?vue&type=template&id=b74409a2&scoped=true&"
import script from "./VehicleSchedulePageV4.vue?vue&type=script&lang=js&"
export * from "./VehicleSchedulePageV4.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSchedulePageV4.vue?vue&type=style&index=0&id=b74409a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74409a2",
  null
  
)

export default component.exports